<template>
  <div class="cf-drop-down-menu-list">
    <slot />
  </div>
</template>


<script>
  export default {
    name: 'DropDownMenuList',

    props: {
      isHamburgerMenuOpen: {
        type: Boolean,
        default: false
      }
    }
  };
</script>
